import React from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FalconCloseButton from 'components/common/FalconCloseButton';
import SelectorCompaniaTarjeta from './SelectorCompaniaTarjeta';

const ModalValidarPago = ({
    show,
    onHide,
    validacion,
    setValidacion,
    cuentasBancarias,
    mediosDePago,
    formaPago,
    onSubmit,
    procesandoModal
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>Validar Pago #{validacion.idPago}</Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={onHide} />
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={12} xl={12} xxl={12} className="text-center text-md-center text-xl-center text-xxl-center">
                        <div className="fs-2 fw-semi-bold">Total del Pago:</div>
                        <div className="fs-4 fw-semi-bold">
                            <span className="text-danger">
                                ${parseFloat(validacion.dTotalPago).toLocaleString("es-MX", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })}
                            </span> {validacion.vMoneda}
                        </div>
                        <hr></hr>
                    </Col>
                </Row>

                <Form.Group className="mb-3">
                    <Form.Label>Destino del ingreso</Form.Label>
                    <Form.Select
                        onChange={(e) => setValidacion({ ...validacion, idCatCuentaBancaria: e.target.value })}
                        className="mb-3"
                        required
                        defaultValue={validacion.idCatCuentaBancaria}
                    >
                        <option value="">Selecciona destino del ingreso</option>
                        {cuentasBancarias.map((fp, index) => {
                            return <option key={index} value={fp.idCatCuentaBancaria}>CTA - {fp.vNumCta} - {fp.vAlias}</option>
                        })}
                    </Form.Select>
                </Form.Group>

                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Medio de pago</Form.Label>
                            <Form.Select
                                onChange={(e) => setValidacion({ ...validacion, idCatMedioPago: e.target.value })}
                                className="mb-3"
                                required
                                defaultValue={validacion.idCatMedioPago}
                            >
                                <option value="0">Selecciona un medio de pago</option>
                                {mediosDePago.map((medioPago, index) => {
                                    return <option key={index} value={medioPago.idCatMedioPago}>{medioPago.vMedioPago}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Tipo de cambio</Form.Label>
                            <Form.Control
                                onChange={(e) => setValidacion({ ...validacion, dTipoCambio: e.target.value })}
                                type="number"
                                size="md"
                                required
                                disabled={validacion.vMoneda == 'MXN'}
                                value={validacion.dTipoCambio}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Forma de pago</Form.Label>
                            <Form.Select
                                onChange={(e) => setValidacion({
                                    ...validacion,
                                    idCatFormaPago: e.target.value,
                                    vJsonDetallesLinkPago: {
                                        ...validacion.vJsonDetallesLinkPago,
                                        vCardType: e.target.value === "4" ? 'credit' : e.target.value === "18" ? 'debit' : ''
                                    }
                                })}
                                className="mb-3"
                                required
                                defaultValue={validacion.idCatFormaPago}
                            >
                                <option value="0">Selecciona un medio de pago</option>
                                {formaPago.map((fp, index) => {
                                    return <option key={index} value={fp.idCatFormaPago}>{fp.vDescripcionFormaPago}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                {(parseInt(validacion.idCatFormaPago) === 4 || parseInt(validacion.idCatFormaPago) === 18) && (
                    <SelectorCompaniaTarjeta
                        value={validacion.vJsonDetallesLinkPago?.vCardCompany || ""}
                        onChange={(value) => {
                            setValidacion({
                                ...validacion,
                                vJsonDetallesLinkPago: {
                                    ...validacion.vJsonDetallesLinkPago,
                                    vCardCompany: value
                                }
                            });
                        }}
                    />
                )}

                <Form.Group className="mb-3">
                    <Form.Label>Folio / Rastreo / Ref.</Form.Label>
                    <Form.Control
                        onChange={(e) => setValidacion({ ...validacion, vReferencia: e.target.value })}
                        type="text"
                        size="md"
                        required
                        value={validacion.vReferencia}
                    />
                </Form.Group>

                <Row>
                    <Col>
                        {Object.keys(validacion.vJsonDetallesLinkPago).length > 0 && (
                            <Row className="fs--1 border-bottom fst-italic pb-2">
                                <Col className="col-5 text-start align-content-center">
                                    Datos extra del pago
                                </Col>
                                <Col className="col-7">
                                    <Row className="justify-content-end">
                                        {validacion.vJsonDetallesLinkPago.vClientName && (
                                            <Col className="col-12 text-end">
                                                {validacion.vJsonDetallesLinkPago.vClientName}
                                            </Col>
                                        )}
                                        {validacion.vJsonDetallesLinkPago.vClientMail && (
                                            <Col className="col-12 text-end">
                                                {validacion.vJsonDetallesLinkPago.vClientMail}
                                            </Col>
                                        )}
                                        {validacion.vJsonDetallesLinkPago.vLastFourCardDigits && (
                                            <Col className="col-12 text-end">
                                                {"**** **** **** " + validacion.vJsonDetallesLinkPago.vLastFourCardDigits}
                                            </Col>
                                        )}
                                        {(validacion.vJsonDetallesLinkPago.vCardCompany || validacion.vJsonDetallesLinkPago.vCardType) && (
                                            <Col className="col-12 text-end">
                                                {validacion.vJsonDetallesLinkPago.vCardCompany && (
                                                    <span>{validacion.vJsonDetallesLinkPago.vCardCompany + " "}</span>
                                                )}
                                                {validacion.vJsonDetallesLinkPago.vCardType && (
                                                    <span>{validacion.vJsonDetallesLinkPago.vCardType + " card"}</span>
                                                )}
                                            </Col>
                                        )}
                                        <Col className="col-12 text-end">
                                            {(validacion.vJsonDetallesLinkPago.vBank == null || validacion.vJsonDetallesLinkPago.vBank == "")
                                                ? "No bank data"
                                                : "Banco " + validacion.vJsonDetallesLinkPago.vBank}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onHide} variant='primary'>Cerrar</Button>
                {procesandoModal ? (
                    <Button variant="primary" disabled>
                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                        Procesando...
                    </Button>
                ) : (
                    <Button type="submit" onClick={onSubmit} variant='success'>VALIDAR PAGO</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

ModalValidarPago.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    validacion: PropTypes.object.isRequired,
    setValidacion: PropTypes.func.isRequired,
    cuentasBancarias: PropTypes.array.isRequired,
    mediosDePago: PropTypes.array.isRequired,
    formaPago: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    procesandoModal: PropTypes.bool.isRequired
};

export default ModalValidarPago;
